var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditorDirectLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01953 11.9995C2.01953 6.48953 6.48953 2.01953 11.9995 2.01953C17.5095 2.01953 21.9795 6.48953 21.9795 11.9995C21.9795 17.5095 17.5095 21.9795 11.9995 21.9795C6.48953 21.9795 2.01953 17.5095 2.01953 11.9995ZM11.481 13.7392V17.8792C11.481 18.4092 12.191 18.5792 12.431 18.0992L15.991 10.9792C16.151 10.6492 15.911 10.2592 15.541 10.2592H13.001V6.06921C13.001 5.53921 12.291 5.36921 12.061 5.83921L8.38103 13.0092C8.20103 13.3392 8.45103 13.7392 8.82103 13.7392H11.481Z",
    fill: "#334D6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorDirectLink);
export default __webpack_public_path__ + "static/media/icon-editor-direct-link.e3b6c8f37cbac6c89629ba2266a6898e.svg";
export { ForwardRef as ReactComponent };